export default __webpack_public_path__ + "static/logos-hp-132c6804d7be4e2fb80716db7a268cdb.png";